export enum LocalStorageKeys {
    translations = "translations",
    currentLanguage = "afwCurrentLanguage",
    authToken = "authToken",
    userType = "userType"
}
